import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const TrackerTobaccoIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00879 8.375V8.68873C11.3984 9.4274 13.9447 12.3804 13.9447 15.9144C13.9447 17.8582 13.1596 19.6161 11.9013 20.9391H20.7654C21.446 20.9391 21.9988 20.3598 21.9988 19.6476V8.375H8.00879Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7644 0.387695H19.4249V3.12493C19.4249 4.36823 18.4438 5.27123 17.0893 5.27123H12.9179C11.5866 5.27123 10.5824 4.34997 10.5824 3.12493V0.387695H9.18305C8.52405 0.387695 8.00781 0.955394 8.00781 1.67913V6.71538H21.9994V1.67913C21.9994 0.967014 21.445 0.387695 20.7644 0.387695Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2432 3.12566C12.2432 3.59875 12.8507 3.61203 12.9204 3.61203H17.0902C17.3425 3.61203 17.7674 3.54895 17.7674 3.12566V0.388426H17.7608C17.5234 0.151054 17.1865 0 16.7947 0H13.2159C12.8241 0 12.4855 0.151054 12.2481 0.388426H12.2432V3.12566Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.29475 20.6163C8.79513 20.6163 10.8285 18.5358 10.8285 15.9774C10.8285 13.419 8.79513 11.3368 6.29475 11.3368C3.79436 11.3368 1.75935 13.419 1.75935 15.9774C1.75935 18.5358 3.79436 20.6163 6.29475 20.6163ZM6.29475 9.68262C9.7648 9.68262 12.5879 12.5048 12.5879 15.9774C12.5879 19.4466 9.7648 22.2705 6.29475 22.2705C2.82307 22.2705 0 19.4466 0 15.9774C0 12.5048 2.82307 9.68262 6.29475 9.68262ZM6.29475 12.7014C8.05896 12.7014 9.49563 14.1714 9.49563 15.9766C9.49563 17.7817 8.05896 19.2517 6.29475 19.2517C4.53053 19.2517 3.09386 17.7817 3.09386 15.9766C3.09386 14.1714 4.53053 12.7014 6.29475 12.7014Z"
        fill={color}
      />
    </IconBase>
  );
};

export default TrackerTobaccoIcon;
